import { createAction } from 'redux-actions';

let errorTimeout;
export const setError = (msg, timeout) => {
  return dispatch => {
    if (errorTimeout) {
      clearTimeout(errorTimeout);
    }
    dispatch(createAction('SET_ERROR')(msg));
    if (timeout) {
      errorTimeout = setTimeout(() => {
        dispatch(createAction('SET_ERROR')(''));
      }, timeout);
    }
  };
};

let infoTimeout;
export const setInfo = (msg, timeout) => {
  return dispatch => {
    if (infoTimeout) {
      clearTimeout(infoTimeout);
    }
    dispatch(createAction('SET_INFO')(msg));
    if (timeout) {
      infoTimeout = setTimeout(() => {
        dispatch(createAction('SET_INFO')(''));
      }, timeout);
    }
  };
};

let okTimeout;
export const setOk = (msg, timeout) => {
  return dispatch => {
    if (okTimeout) {
      clearTimeout(okTimeout);
    }
    dispatch(createAction('SET_OK')(msg));
    if (timeout) {
      okTimeout = setTimeout(() => {
        dispatch(createAction('SET_OK')(''));
      }, timeout);
    }
  };
};
